"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _structure = _interopRequireDefault(require("../../../editor-templates/templates/urban/structure"));

var _structure2 = _interopRequireDefault(require("../../../editor-templates/templates/business/structure"));

var _structure3 = _interopRequireDefault(require("../../../editor-templates/templates/trade/structure"));

var _structure4 = _interopRequireDefault(require("../../../editor-templates/templates/sleek/structure"));

var _structure5 = _interopRequireDefault(require("../../../editor-templates/templates/global/structure"));

var _structure6 = _interopRequireDefault(require("../../../editor-templates/templates/insider/structure"));

var _structure7 = _interopRequireDefault(require("../../../editor-templates/templates/classic/structure"));

var _structure8 = _interopRequireDefault(require("../../../editor-templates/templates/common/structure"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  urban: _structure.default,
  trade: _structure3.default,
  business: _structure2.default,
  sleek: _structure4.default,
  global: _structure5.default,
  insider: _structure6.default,
  classic: _structure7.default,
  common: _structure8.default
};
exports.default = _default;